import { useMutation, useQuery } from '@apollo/client';
import { GET_ALL_TEMPLATELIST } from '@nile/graphql';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { useProduct } from '@nile/components';
import { removePropertiesForItProduct } from '@nile/itsm';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { CREATE_PROJECT, GET_PROJECTS } from '@nile/projects/src/Graphql';
import { ProjectForm } from '../Components/Forms';

const NewProjectContainer = (props) => {
  const tabContext = useContext(TabContext);
  const flags = useFlags();
  const currentProduct = useProduct();

  const { loading: templatesLoading, error, data: allTemplates } = useQuery(
    GET_ALL_TEMPLATELIST
  );

  const [createProjectWithInterceptor] = useMutation(CREATE_PROJECT, {
    onCompleted({ createProject: createProjectData }) {},
    update(cache, { data }) {
      const cachedQueries = cache?.data?.data?.ROOT_QUERY;
      const allKeys = cachedQueries ? Object.keys(cachedQueries) : [];
      if (allKeys.indexOf('getProjects') === -1) {
        return;
      }
      const projects = cache.readQuery({
        query: GET_PROJECTS
      });

      cache.writeQuery({
        query: GET_PROJECTS,
        data: {
          getProjects: [...projects.getProjects, data.createProject]
        }
      });
    },
    onError({ graphQLErrors }) {
      // if (graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
      //   toast(
      //     'error',
      //     <FormattedMessage
      //       id={
      //         ERROR_CODES[graphQLErrors[0].extensions.clientError[0].errorCode]
      //       }
      //     />
      //   );
      // } else {
      //   // toast('error', 'Something went wrong');
      // }
    }
  });

  async function createProject(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'createProject',
        currentProduct
      );

      return await createProjectWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const back = () => {
    tabContext.closeTab();
  };

  const actions = {
    primaryAction: createProject,
    back: back,
    ...props.actions
  };

  return (
    <ProjectForm
      actions={actions}
      flags={flags}
      taskTemplates={allTemplates}
      activeTab={tabContext.activeTab}
      context={tabContext}
    />
  );
};

export default withRouter(NewProjectContainer);
